import posthog from "posthog-js";
import { hasAnalyticsConsent } from "./cookieConsent";

const DEFAULT_POSTHOG_HOST = "https://eu.i.posthog.com";

let posthogInitialized = false;

export function getPostHogConfig() {
  const apiKey = String(process.env.REACT_APP_POSTHOG_KEY || "").trim();
  const apiHost = String(process.env.REACT_APP_POSTHOG_HOST || DEFAULT_POSTHOG_HOST).trim() || DEFAULT_POSTHOG_HOST;
  return { apiKey, apiHost, enabled: Boolean(apiKey) };
}

/** Idempotent PostHog init — only after analytics consent. */
export function initPostHogIfNeeded() {
  const { apiKey, apiHost, enabled } = getPostHogConfig();
  if (!enabled || !hasAnalyticsConsent() || posthogInitialized) return false;
  posthog.init(apiKey, {
    api_host: apiHost,
    capture_pageview: false,
    autocapture: false,
    persistence: "localStorage+cookie",
  });
  posthogInitialized = true;
  return true;
}

export function shutdownPostHog() {
  if (!posthogInitialized) return;
  try {
    posthog.opt_out_capturing();
    posthog.reset(true);
  } catch {
    /* ignore teardown errors */
  }
  posthogInitialized = false;
}

export function isPostHogInitialized() {
  return posthogInitialized;
}

/** Map API roles to analytics-friendly applicant / hiring labels (no PII). */
export function mapUserRoleForAnalytics(role) {
  if (role === "applicant") return "applicant";
  if (role === "hiring-manager" || role === "recruiter") return "hiring";
  return String(role || "").trim() || undefined;
}
